import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { ListService } from "../services/list-service";
import { CustomViewsService } from "../services/custom-views-service";

import * as angular from "angular";
import { AclService } from "../services/acl-service";
import { EntityConfigService } from "../services/entity-config-service"
import { NotifyService } from "../services/notify-service";
import { AccountService } from "../services/account-service";
import { CommentService } from "../services/comment-service";

RLColumnPicker.$inject = ['$uibModal', '$timeout'];

export function RLColumnPicker($uibModal: angular.ui.bootstrap.IModalService, $timeout: ng.ITimeoutService): ng.IDirective {
    return {
        restrict: 'E',
        scope: {
            charTypeID: '=charTypeId',
            templateID: '=?templateId',
            selectedCustomColumns: '=',
            onColumnsSelected: '&?',
            overrideCharTypeId: '=',
            dropdownPlacement: '@?'
        },
        template: require("/assets/app/templates/column-picker.html"),
        bindToController: true,
        controllerAs: 'cpVM',
        controller: RLColumnPickerController,
        link: ($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attrs: ng.IAttributes) => {
            // already in modal
            $timeout(() => {
                $scope['preventDefault'] = angular.element('body').hasClass('modal-open');
            }, 500);
        }
    }
}

export class RLColumnPickerController {
    static $inject = ['$rootScope', '$window', '$scope', '$uibModal', '$q', 'aclService', 'notifyService', 'entityConfigService', 'accountService', 'customViewsService', 'listService'];

    charTypeID: number;
    templateID: number;
    dropdownPlacement: string;
    overrideCharTypeId: number;
    characteristics: Models.ICharacteristic[] = [];
    columns: Models.ICustomUserColumn[] = [];
    selectedCustomColumns: Models.ICustomUserColumns;
    specialColumns: Models.ICustomUserColumns;
    globalColumns: Models.ICustomUserColumns[] = [];
    customColumns: Models.ICustomUserColumns[] = [];
    canHazGlobal: boolean;
    onColumnsSelected: (event: { columns: Models.ICustomUserColumns }) => any;
    moduleLevelCharTypeIDs: { [id: string]: number } = Consts.ModuleLevelCharTypes.IDs;
    parties: Models.IParty[];
    visibleColumns: Models.ICustomUserColumns;

    constructor(
        private $rootScope: ng.IRootScopeService,
        private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $q: angular.IQService,
        private aclService: AclService,
        private notifyService: NotifyService,
        private entityConfigService: EntityConfigService,
        private accountService: AccountService,
        private customViewsService: CustomViewsService,
        private listService: ListService) {

        $scope.$watch(() => this.charTypeID, (newValue, oldValue) => {
            if (this.charTypeID) {
                this.getCharacteristics(this.charTypeID)
                    .then(() => {
                        if (this.templateID == undefined || this.templateID == 0) {
                            this.getFirstCharacteristicTemplateForCharType(this.charTypeID)
                                .then(() => {
                                    this.getCustomColumns(this.charTypeID, this.templateID);
                                });
                        }
                        else {
                            this.getCustomColumns(this.charTypeID, this.templateID);
                        }
                    });
            }
        });

        $scope.$on(Consts.Events.NewViewCreated, (event, charTypeID, customColumns: Models.ICustomUserColumns) => {
            if (charTypeID == this.charTypeID) {
                if (!customColumns.isGlobal) {
                    this.customColumns.push(customColumns);
                } else {
                    this.globalColumns.push(customColumns);
                }
            }
        });

        this.aclService.loadAcls()
            .then((acls) => {
                this.canHazGlobal = Utils.AclUtil.hasAccess(acls, Utils.AclUtil.getAclUrl(this.overrideCharTypeId || this.charTypeID), Consts.AccessRight.Admin);
            });

        if (!this.dropdownPlacement) this.dropdownPlacement = "dropdown-menu-right";
    }

    private getCharacteristics(charTypeID: number): ng.IPromise<void> {
        this.notifyService.startProgress();
        return this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                this.characteristics = res;
                this.setupColumns(charTypeID, this.characteristics);
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private getFirstCharacteristicTemplateForCharType(charTypeID: number) {
        return this.entityConfigService.getDefaultCharacteristicTemplate(charTypeID)
            .then((result) => {
                this.templateID = result.templateID;
            });
    }

    private getVisibleColumns(charTypeID: number, templateID: number): ng.IPromise<Models.ICustomUserColumns> {
        let deferred = this.$q.defer<Models.ICustomUserColumns>();
        this.entityConfigService.getCharacteristicTemplate(charTypeID, templateID)
            .then((res) => {
                let columns = this.listService.GetColumnsFromMetaData(res, this.aclService.acls);
                let visibleColumns = {
                    charTypeID: this.charTypeID,
                    name: 'Visible Characteristics',
                    isDefault: false,
                    isGlobal: false,
                    columns: columns
                };
                deferred.resolve(visibleColumns);
            });
        return deferred.promise;
    }

    private getSpecialColumns(charTypeID: number, templateID: number): ng.IPromise<Models.ICustomUserColumn[]> {
        let deferred = this.$q.defer<Models.ICustomUserColumn[]>();
        var specialColumns: Models.ICustomUserColumn[] = []

        if (_.any(this.moduleLevelCharTypeIDs, (id) => id == this.charTypeID)) {
            this.entityConfigService.getParties().then((result) => {
                if (result) {
                    if (result.success)
                        this.parties = result.data;
                }
            }).finally(() => {
                specialColumns = this.customViewsService.GetSpecialColumns(charTypeID, this.parties);
                deferred.resolve(specialColumns);
            });
        }
        else {
            deferred.resolve(specialColumns);
        }
        return deferred.promise;
    }

    private getCustomColumns(charTypeID: number, templateID: number) {
        return this.accountService.getCustomColumns(charTypeID)
            .then((res) => {
                this.getVisibleColumns(charTypeID, templateID).then(
                    (visibleColumns) => {
                        this.visibleColumns = visibleColumns;


                    }).then(() => {
                        this.getSpecialColumns(charTypeID, templateID).then(
                            (specialColumns) => {
                                if (res.length === 0 && !this.selectedCustomColumns && !templateID) {
                                    if (this.charTypeID == Consts.CharTypeIDs.right) {
                                        this.selectedCustomColumns = this.visibleColumns;
                                    }
                                    else this.selectedCustomColumns = this.customViewsService.GetDefaultColumns(charTypeID);
                                } else if (res.length === 0 && !this.selectedCustomColumns) {
                                    this.selectedCustomColumns = this.visibleColumns;
                                }
                                else {
                                    var globalColumns = _.filter(res, (columns) => {
                                        return columns.isGlobal;
                                    });

                                    var userColumns = _.filter(res, (columns) => {
                                        return !columns.isGlobal;
                                    });

                                    this.globalColumns = globalColumns;
                                    this.customColumns = userColumns;

                                    // only if nothing previously set this
                                    if (this.selectedCustomColumns == null || _.isEmpty(this.selectedCustomColumns)) {
                                        let defaultUserCustomColumns = _.find(userColumns, (cols) => {
                                            return cols.isDefault;
                                        });
                                        if (defaultUserCustomColumns != undefined) {
                                            defaultUserCustomColumns.columns.forEach((col) => {
                                                let visCol = this.visibleColumns.columns.find((c) => {
                                                    return c.characteristicID == col.characteristicID;
                                                });
                                                col.hasLov = visCol != undefined ? visCol.hasLov : false;
                                            });
                                            this.selectedCustomColumns = defaultUserCustomColumns;
                                        } else {
                                            let defaultGlobalCustomColumns = _.find(globalColumns, (cols) => {
                                                return cols.isDefault;
                                            });
                                            if (defaultGlobalCustomColumns) {
                                                this.selectedCustomColumns = defaultGlobalCustomColumns;
                                            } else {
                                                this.selectedCustomColumns = this.customViewsService.GetDefaultColumns(charTypeID);
                                            }
                                        }

                                        if (!this.selectedCustomColumns) {
                                            this.selectedCustomColumns = this.customViewsService.GetDefaultColumns(charTypeID);
                                        }
                                    }

                                    this.selectedCustomColumns.columns.forEach((col) => {
                                        let visCol = this.visibleColumns.columns.find((c) => {
                                            return c.characteristicID == col.characteristicID;
                                        });
                                        if (visCol) col.hasLov = visCol.hasLov;

                                        let specialColumn = specialColumns.find((c) => {
                                            return c.solrLabel == col.solrLabel;
                                        });
                                        if (specialColumn && specialColumn.label != null && specialColumn.label.includes("Party")) {
                                            col.label = specialColumn.label;
                                        }
                                    });
                                }
                            });
                    });
            });
    }

    private setupColumns(charTypeID: number, characteristics: Models.ICharacteristic[]) {
        var columns = _.sortBy(characteristics, (chr) => {
            return chr.label;
        }).map((chr): Models.ICustomUserColumn => {
            return {
                charTypeID: charTypeID,
                solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                label: chr.label,
                characteristicID: chr.characteristicID,
                formatter: this.getFormatter(chr.dataTypeID),
                hasLov: chr.charValueSetID != undefined,
                sequenceNumber: 0
            }
        })
            .filter((chr) => {
                return chr.solrLabel != 'recordid' && chr.solrLabel != 'entity_revision_id_str';
            });

        this.columns = columns;
    }

    private getFormatter(dateTypeID: number) {
        switch (dateTypeID) {
            case Consts.CharDataTypeIDs.CharDataTypes.date: {
                return 'dateLocal:"L"';
            }
            default: {
                return undefined;
            }
        }
    }

    private saveCustomColumns(customColumns: Models.ICustomUserColumns) {
        if (!customColumns.isGlobal && customColumns.isDefault) {
            this.customColumns.forEach((col) => {
                col.isDefault = false;
            });
        } else if (customColumns.isGlobal && customColumns.isDefault) {
            this.globalColumns.forEach((col) => {
                col.isDefault = false;
            });
        }

        this.notifyService.startProgress();
        return this.accountService.createCustomColumns(customColumns)
            .then((res: any) => {
                // if editing then remove the old one
                if (customColumns.headerID) {
                    _.remove(this.customColumns, (col => {
                        return col.headerID == customColumns.headerID;
                    }));

                    _.remove(this.globalColumns, (col => {
                        return col.headerID == customColumns.headerID;
                    }));
                }

                customColumns.headerID = res.id;
                this.$rootScope.$broadcast(Consts.Events.NewViewCreated, this.charTypeID, customColumns);
            })
            .catch((err) => {

            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    DeleteCustomColumns(columns: Models.ICustomUserColumns) {
        if (this.$window.confirm(`Are you sure you want to delete the ${columns.name} View?`)) {
            this.accountService.deleteCustomColumns(columns.headerID)
                .then((res) => {
                    if (!columns.isGlobal) {
                        _.remove(this.customColumns, (col) => {
                            return col.headerID == columns.headerID;
                        });
                    } else {
                        _.remove(this.globalColumns, (col) => {
                            return col.headerID == columns.headerID;
                        });
                    }
                });
        }
    }

    CopyCustomColumns(columns: Models.ICustomUserColumns) {
        var copy = _.cloneDeep(columns);
        copy.headerID = undefined;
        copy.name = undefined;
        copy.isDefault = false;
        copy.isGlobal = false;

        this.EditCustomColumns(copy);
    }

    EditCustomColumns(columns?: Models.ICustomUserColumns) {
        var self = this;
        var modal = this.$uibModal.open({
            animation: true,
            template: require("/assets/app/templates/modals/create-custom-columns.html"),
            controller: CreateCustomColumnsModalController,
            controllerAs: 'cccVM',
            resolve: {
                charTypeID: function () {
                    return self.charTypeID;
                },
                columns: function () {
                    return self.columns;
                },
                editColumns: function () {
                    return columns;
                },
                preventDefault: function () {
                    return self.$scope['preventDefault'];
                },
                overrideCharTypeId: function () {
                    return self.overrideCharTypeId;
                }
            },
            size: 'lg'
        });

        modal.result
            // close
            .then((customColumns) => {
                if (customColumns) {
                    this.saveCustomColumns(customColumns)
                        .then(() => {
                            this.selectedCustomColumns = customColumns;
                        });
                }
            })
            // dismiss
            .catch((customColumns) => {
                if (customColumns) {
                    // just apply, don't save
                    this.selectedCustomColumns = customColumns;
                }
            })
            .finally(() => {

            });
    }

    SelectColumns($event: ng.IAngularEvent, columns: Models.ICustomUserColumns) {
        $event.preventDefault();
        
        this.getSpecialColumns(this.charTypeID, this.templateID).then(
            (specialColumns) => {
                this.selectedCustomColumns = columns;
                this.selectedCustomColumns.columns.forEach((col) => {
                    let visCol = this.visibleColumns.columns.find((c) => {
                        return c.characteristicID == col.characteristicID;
                    });
                    if (visCol) col.hasLov = visCol.hasLov;

                    let specialColumn = specialColumns.find((c) => {
                        return c.solrLabel == col.solrLabel;
                    });
                    if (specialColumn && specialColumn.label != null && specialColumn.label.includes("Party")) {
                        col.label = specialColumn.label;
                    }
                });
                
                if (this.onColumnsSelected != null) {
                    this.onColumnsSelected({ columns: columns });
                }
            });
    }
}

export class CreateCustomColumnsModalController {
    static $inject = ['$scope', '$timeout', 'accountService', 'aclService', 'charTypeID', 'columns', 'editColumns', 'preventDefault', 'overrideCharTypeId', 'customViewsService', 'entityConfigService'];

    specialColumns: Models.ICustomUserColumn[];
    saveName: string;
    selectedColumns: Models.ICustomUserColumn[] = [];
    isDefault: boolean = false;
    isGlobal: boolean = false;
    headerID: number;
    parties: Models.IParty[];

    canHazGlobal: boolean;

    constructor(
        private $scope: angular.ui.bootstrap.IModalScope,
        private $timeout: ng.ITimeoutService,
        private accountService: AccountService,
        private aclService: AclService,
        private charTypeID: number,
        private columns: Models.ICustomUserColumn[],
        private editColumns: Models.ICustomUserColumns,
        private preventDefault: boolean,
        private overrideCharTypeID: number,
        private customViewsService: CustomViewsService,
        private entityConfigService: EntityConfigService) {

        this.charTypeID = charTypeID;
        this.columns = columns;

        this.setupSpecialColumns(charTypeID);

        $scope.$on('modal.closing', (event, reason, closed) => {
            if (this.preventDefault) {
                $timeout(() => {
                    angular.element('body').addClass('modal-open');
                }, 1000);
            }
        });



        this.aclService.loadAcls()
            .then((acls) => {
                this.canHazGlobal = Utils.AclUtil.hasAccess(acls, Utils.AclUtil.getAclUrl(this.overrideCharTypeID || this.charTypeID), Consts.AccessRight.Admin);
            });
    }

    private getCustomColumns(): Models.ICustomUserColumns {
        return {
            charTypeID: this.charTypeID,
            name: this.saveName,
            isDefault: this.isDefault,
            isGlobal: this.isGlobal,
            headerID: this.headerID,
            columns: _.cloneDeep(this.selectedColumns)
        }
    }

    private setupSpecialColumns(charTypeID: number) {
        this.parties = [];

        this.entityConfigService.getParties().then((result) => {
            if (result) {
                if (result.success)
                    this.parties = result.data;
            }
        })
            .finally(() => {
                this.specialColumns = this.customViewsService.GetSpecialColumns(charTypeID, this.parties);
                this.columns = this.columns.concat(this.specialColumns);
                if (!this.editColumns) {
                    this.editColumns = this.customViewsService.GetDefaultColumns(this.charTypeID);
                    this.editColumns.name = undefined;
                    this.editColumns.isDefault = false;
                }

                if (this.editColumns) {
                    this.isDefault = this.editColumns.isDefault;
                    this.isGlobal = this.editColumns.isGlobal;
                    this.headerID = this.editColumns.headerID;
                    this.saveName = this.editColumns.name;

                    this.editColumns.columns.forEach((col) => {
                        var fCol = _.find(this.columns, (tCol) => {
                            return tCol.solrLabel == col.solrLabel;
                        });

                        if (fCol) {
                            fCol.sequenceNumber = col.sequenceNumber;
                            this.selectedColumns.push(fCol);
                        }
                    });
                    if (!this.checkForInvalidSequence(this.selectedColumns)) {
                        var updatedColumns = this.updateSequence(this.selectedColumns);
                        this.selectedColumns = updatedColumns;
                    }
                }
            });
    }

    checkForInvalidSequence(customColumns: Models.ICustomUserColumn[]) {
        let colArray = customColumns.map(x => x.sequenceNumber).sort((a, b) => a - b);

        for (var i = 1, len = colArray.length; i < len; i++) {
            if (colArray[i] <= colArray[i - 1]) {
                return false;
            }
        }
        return true;
    }

    updateSequence(customColumns: Models.ICustomUserColumn[]) {
        customColumns.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
        for (let j = 0; j < customColumns.length; j++) {
            customColumns[j].sequenceNumber = j;
        }
        return customColumns;
    }

    RemoveColumn(column: Models.ICustomUserColumn) {
        var index = -1;
        this.selectedColumns = _.sortBy(this.selectedColumns, (col) => {
            return col.sequenceNumber;
        });

        for (var i = 0; i < this.selectedColumns.length; i++) {
            var col = this.selectedColumns[i];
            if (col === column) {
                col.sequenceNumber = 0;
                index = i;
                continue;
            }

            if (index > -1) {
                col.sequenceNumber--;
            }
        }

        if (index > -1) {
            this.selectedColumns.splice(index, 1);
        }
    }

    SelectColumn(column: Models.ICustomUserColumn) {
        column.sequenceNumber = this.selectedColumns.length;

        this.selectedColumns.push(column);
    }

    Cancel() {
        this.$scope.$dismiss();
    }

    SaveCustomColumns() {
        this.$scope.$close(this.getCustomColumns());
    }

    ApplyCustomColumns($event: ng.IAngularEvent) {
        this.$scope.$dismiss(this.getCustomColumns());
    }

    AdjustSequenceNumber(column: Models.ICustomUserColumn, sequenceNumber: number) {
        var col = _.find(this.selectedColumns, (col) => {
            return col.sequenceNumber == sequenceNumber;
        });

        col.sequenceNumber = column.sequenceNumber;
        column.sequenceNumber = sequenceNumber;
    }
}